var e = /* @__PURE__ */ ((r) => (r.darkgreen = "darkgreenGradient", r.blue = "blueGradient", r.orange = "orangeGradient", r.gray = "grayGradient", r.red = "redGradient", r))(e || {});
export {
  e as Gradient
};
//# sourceMappingURL=propsTypes.js.map
